/* Canadian Off Grid consultation booking (replaces Hoppy on the live theme).
 *
 * A plain-JS copy of the web shop's booking widget
 * (src/components/shop/booking/booking-widget.tsx in the Gru repo): pick a kind
 * → a day and a time from everyone who offers it → your details → requested.
 * Talks only to the store's own app proxy (/apps/book/…), which Shopify signs
 * and forwards. Mounted by sections/cog-booking.liquid on
 * <div data-cog-booking data-proxy="/apps/book" data-locale="en|fr">.
 * Keep the two widgets in step.
 */
(function () {
  "use strict";

  var T = {
    en: {
      step1: "How would you like to meet?", step2: "Pick a day and time", step3: "Your details",
      in_person: ["Showroom visit", "Come see the gear in person at our showroom."],
      phone: ["Phone consultation", "We call you — talk through your project."],
      video: ["Video call", "Face to face, wherever you are."],
      min: "min", anyone: "First available", with: "with",
      noTimes: "No open times this month.", nextMonth: "Try next month",
      pickDay: "Pick a day to see open times.", times: "Open times", tz: "Times shown in",
      name: "Your name", email: "Email", phoneField: "Phone", phoneCall: "Phone (we'll call this number)",
      notes: "What would you like to talk about? (optional)",
      notesHint: "Your system, a quote, a product — anything that helps us prepare.",
      book: "Request appointment", booking: "Sending…", change: "Change",
      doneTitle: "Request sent!", doneBody: "We'll email you as soon as your appointment is confirmed.",
      manage: "See or cancel your request", loading: "Loading…",
      guests: "Anyone joining you? (emails, optional)", guestsHint: "They'll get the invite too.", choose: "Choose…", prep: "Before we talk",
      none: "Bookings aren't available online right now. Please call or email us and we'll set up a time.",
      error: "Something went wrong. Please try again.", prev: "Previous month", next: "Next month"
    },
    fr: {
      step1: "Comment souhaitez-vous nous rencontrer?", step2: "Choisissez une date et une heure", step3: "Vos coordonnées",
      in_person: ["Visite en salle d'exposition", "Venez voir l'équipement en personne."],
      phone: ["Consultation téléphonique", "Nous vous appelons pour parler de votre projet."],
      video: ["Appel vidéo", "En face à face, où que vous soyez."],
      min: "min", anyone: "Premier disponible", with: "avec",
      noTimes: "Aucune disponibilité ce mois-ci.", nextMonth: "Essayer le mois suivant",
      pickDay: "Choisissez une date pour voir les heures disponibles.", times: "Heures disponibles", tz: "Heures affichées en",
      name: "Votre nom", email: "Courriel", phoneField: "Téléphone", phoneCall: "Téléphone (nous vous appellerons à ce numéro)",
      notes: "De quoi aimeriez-vous parler? (facultatif)",
      notesHint: "Votre système, une soumission, un produit — tout ce qui nous aide à nous préparer.",
      book: "Demander un rendez-vous", booking: "Envoi…", change: "Modifier",
      doneTitle: "Demande envoyée!", doneBody: "Nous vous écrirons dès que votre rendez-vous sera confirmé.",
      manage: "Voir ou annuler votre demande", loading: "Chargement…",
      guests: "Quelqu'un se joint à vous? (courriels, facultatif)", guestsHint: "Ces personnes recevront aussi l'invitation.", choose: "Choisir…", prep: "Avant notre rencontre",
      none: "La réservation en ligne n'est pas disponible pour le moment. Appelez-nous ou écrivez-nous et nous fixerons un rendez-vous.",
      error: "Une erreur s'est produite. Veuillez réessayer.", prev: "Mois précédent", next: "Mois suivant"
    }
  };
  var MODES = ["in_person", "phone", "video"];
  var ICONS = {
    in_person: '<path d="M3 21h18M5 21V8l7-5 7 5v13"/><path d="M9 21v-6h6v6"/>',
    phone: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/>',
    video: '<rect x="2" y="6" width="14" height="12" rx="2"/><path d="m22 8-6 4 6 4V8z"/>'
  };

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function dayKey(d) { return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()); }
  function uniq(list) { var out = []; list.forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); }); return out; }

  /** h("button", { class: "x", onclick: fn }, [children]) — text children are set as text, never HTML. */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v === false || v == null) return;
      if (k.slice(0, 2) === "on") el.addEventListener(k.slice(2), v);
      else if (k === "html") el.innerHTML = v;
      else el.setAttribute(k, v === true ? "" : v);
    });
    (kids || []).forEach(function (c) { if (c != null && c !== false) el.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return el;
  }

  function mount(root) {
    var locale = root.getAttribute("data-locale") === "fr" ? "fr" : "en";
    var proxy = root.getAttribute("data-proxy") || "/apps/book";
    var t = T[locale];
    // A private booking link (?link=… on the page): its one unlisted schedule.
    var link = new URLSearchParams(location.search).get("link") || "";
    var intl = locale === "fr" ? "fr-CA" : "en-CA";
    var now = new Date();
    var thisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    var lastMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth() + 2, 1);
    var S = {
      schedules: null, mode: null, duration: null, hostId: null, month: thisMonth,
      slots: null, day: null, slot: null, form: { name: "", email: "", phone: "", notes: "", guests: "", website: "" }, answers: {},
      busy: false, error: null, doneToken: null
    };
    var request = 0;

    function fmt(opts, d) { return new Intl.DateTimeFormat(intl, opts).format(d); }
    function fmtLong(iso) { return fmt({ weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" }, new Date(iso)); }
    function zoneName() {
      try {
        var p = new Intl.DateTimeFormat(intl, { timeZoneName: "long" }).formatToParts(new Date());
        for (var i = 0; i < p.length; i++) if (p[i].type === "timeZoneName") return p[i].value;
      } catch (e) { /* older browsers */ }
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    function forMode() { return (S.schedules || []).filter(function (s) { return S.mode && s.modes.indexOf(S.mode) >= 0; }); }
    function durations() { return uniq(forMode().map(function (s) { return s.durationMinutes; })).sort(function (a, b) { return a - b; }); }
    function hosts() { return forMode().filter(function (s) { return !S.duration || s.durationMinutes === S.duration; }); }
    function byDay() {
      var m = {};
      (S.slots || []).forEach(function (s) { var k = dayKey(new Date(s.start)); (m[k] = m[k] || []).push(s); });
      return m;
    }
    // The questions and prep notes of the schedules behind the picked time.
    function slotSchedules() { return S.slot ? (S.schedules || []).filter(function (x) { return S.slot.scheduleIds.indexOf(x.id) >= 0; }) : []; }
    function questions() {
      var seen = {}, out = [];
      slotSchedules().forEach(function (x) { (x.questions || []).forEach(function (q) { if (!seen[q.id]) { seen[q.id] = 1; out.push(q); } }); });
      return out;
    }
    function prepNotes() { var x = slotSchedules().filter(function (y) { return y.prepNotes; })[0]; return x ? x.prepNotes : null; }
    function hostOf(slot) {
      var names = uniq(slot.scheduleIds.map(function (id) { var s = (S.schedules || []).filter(function (x) { return x.id === id; })[0]; return s && s.hostFirstName; }).filter(Boolean));
      return names.length === 1 ? names[0] : null;
    }

    function settle() {
      var modes = MODES.filter(function (m) { return (S.schedules || []).some(function (s) { return s.modes.indexOf(m) >= 0; }); });
      if (!S.mode && modes.length === 1) S.mode = modes[0];
      var ds = durations();
      if (ds.length && (!S.duration || ds.indexOf(S.duration) < 0)) S.duration = ds[0];
      return modes;
    }

    function loadSlots() {
      if (!S.mode || !S.duration) return;
      var mine = ++request;
      var from = S.month < new Date() ? new Date() : S.month;
      var to = new Date(S.month.getFullYear(), S.month.getMonth() + 1, 1);
      var qs = "mode=" + S.mode + "&duration=" + S.duration + "&from=" + encodeURIComponent(from.toISOString()) + "&to=" + encodeURIComponent(to.toISOString());
      if (S.hostId) qs += "&scheduleId=" + encodeURIComponent(S.hostId);
      if (link) qs += "&link=" + encodeURIComponent(link);
      S.slots = null;
      render();
      fetch(proxy + "/availability?" + qs, { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : { slots: [] }; })
        .then(function (d) {
          if (mine !== request) return;
          S.slots = d.slots || [];
          var map = byDay();
          if (!S.day || !map[S.day]) S.day = Object.keys(map).sort()[0] || null;
          render();
        })
        .catch(function () { if (mine === request) { S.slots = []; render(); } });
    }

    function set(patch, reload) {
      Object.keys(patch).forEach(function (k) { S[k] = patch[k]; });
      settle();
      if (reload) loadSlots(); else render();
    }

    function deviceZone() {
      try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (err) { return null; }
    }

    function submit(e) {
      e.preventDefault();
      if (!S.slot || !S.mode || S.busy) return;
      S.busy = true; S.error = null; render();
      var body = { name: S.form.name, email: S.form.email, phone: S.form.phone, notes: S.form.notes, website: S.form.website, guests: S.form.guests, answers: S.answers, link: link || null, mode: S.mode, start: S.slot.start, scheduleIds: S.slot.scheduleIds, locale: locale, timeZone: deviceZone() };
      fetch(proxy + "/bookings", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            S.busy = false;
            if (!r.ok) {
              S.error = d.error || t.error;
              if (r.status === 409) { S.slot = null; loadSlots(); return; }
              render();
              return;
            }
            S.doneToken = d.token || "";
            render();
            root.scrollIntoView({ behavior: "smooth", block: "start" });
          });
        })
        .catch(function () { S.busy = false; S.error = t.error; render(); });
    }

    function num(n) { return h("span", { class: "cog-bk-num" }, [String(n)]); }

    function render() {
      root.innerHTML = "";
      if (S.schedules === null) { root.appendChild(h("div", { class: "cog-bk-box cog-bk-center" }, [t.loading])); return; }
      var modes = settle();
      if (!modes.length) { root.appendChild(h("div", { class: "cog-bk-box cog-bk-center" }, [t.none])); return; }
      var location = (hosts().filter(function (s) { return s.location; })[0] || {}).location || null;

      if (S.doneToken !== null && S.slot && S.mode) {
        root.appendChild(h("div", { class: "cog-bk-box cog-bk-done" }, [
          h("div", { class: "cog-bk-tick", html: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>' }),
          h("h3", {}, [t.doneTitle]),
          h("p", { class: "cog-bk-strong" }, [t[S.mode][0]]),
          h("p", { class: "cog-bk-muted" }, [fmtLong(S.slot.start)]),
          S.mode === "in_person" && location ? h("p", { class: "cog-bk-muted" }, [location]) : null,
          h("p", {}, [t.doneBody]),
          prepNotes() ? h("div", { class: "cog-bk-prep" }, [h("p", { class: "cog-bk-strong" }, [t.prep]), h("p", { class: "cog-bk-muted cog-bk-pre" }, [prepNotes()])]) : null,
          S.doneToken ? h("a", { class: "cog-bk-link", href: proxy + "/manage/" + encodeURIComponent(S.doneToken) + (locale === "fr" ? "?locale=fr" : "") }, [t.manage]) : null
        ]));
        return;
      }

      var box = h("div", { class: "cog-bk-box" });

      // 1. Kind
      var s1 = h("div", { class: "cog-bk-step" }, [h("h3", { class: "cog-bk-title" }, [num(1), t.step1])]);
      s1.appendChild(h("div", { class: "cog-bk-modes cog-bk-modes-" + modes.length }, modes.map(function (m) {
        return h("button", { type: "button", class: "cog-bk-mode" + (S.mode === m ? " is-on" : ""), "aria-pressed": S.mode === m ? "true" : "false", onclick: function () { set({ mode: m, slot: null, hostId: null, duration: null }, true); } }, [
          h("span", { class: "cog-bk-icon", html: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[m] + "</svg>" }),
          h("span", { class: "cog-bk-strong" }, [t[m][0]]),
          h("span", { class: "cog-bk-muted cog-bk-sm" }, [t[m][1]])
        ]);
      })));
      var ds = durations(), hs = hosts();
      if (S.mode && (ds.length > 1 || hs.length > 1)) {
        var chips = h("div", { class: "cog-bk-chips" });
        if (ds.length > 1) ds.forEach(function (d) { chips.appendChild(h("button", { type: "button", class: "cog-bk-chip" + (S.duration === d ? " is-on" : ""), onclick: function () { set({ duration: d, slot: null }, true); } }, [d + " " + t.min])); });
        if (hs.length > 1) {
          chips.appendChild(h("button", { type: "button", class: "cog-bk-chip" + (!S.hostId ? " is-on" : ""), onclick: function () { set({ hostId: null, slot: null }, true); } }, [t.anyone]));
          hs.forEach(function (x) {
            chips.appendChild(h("button", { type: "button", class: "cog-bk-chip" + (S.hostId === x.id ? " is-on" : ""), onclick: function () { set({ hostId: x.id, slot: null }, true); } }, [
              x.hostImage ? h("img", { src: x.hostImage, alt: "", class: "cog-bk-avatar", referrerpolicy: "no-referrer" }) : h("span", { class: "cog-bk-avatar" }, [x.hostFirstName.charAt(0)]),
              x.hostFirstName
            ]));
          });
        }
        s1.appendChild(chips);
      }
      box.appendChild(s1);

      // 2. Day + time
      if (S.mode) {
        var s2 = h("div", { class: "cog-bk-step" }, [h("h3", { class: "cog-bk-title" }, [num(2), t.step2])]);
        if (S.slot) {
          var who = hostOf(S.slot);
          s2.appendChild(h("div", { class: "cog-bk-picked" }, [
            h("span", { class: "cog-bk-strong" }, [fmtLong(S.slot.start) + " · " + S.duration + " " + t.min + (who ? " · " + t.with + " " + who : "")]),
            h("button", { type: "button", class: "cog-bk-link", onclick: function () { set({ slot: null }); } }, [t.change])
          ]));
        } else {
          var map = byDay();
          var cal = h("div", {});
          cal.appendChild(h("div", { class: "cog-bk-monthbar" }, [
            h("button", { type: "button", class: "cog-bk-nav", "aria-label": t.prev, disabled: S.month <= thisMonth, onclick: function () { set({ month: new Date(S.month.getFullYear(), S.month.getMonth() - 1, 1) }, true); } }, ["‹"]),
            h("span", { class: "cog-bk-strong cog-bk-cap" }, [fmt({ month: "long", year: "numeric" }, S.month)]),
            h("button", { type: "button", class: "cog-bk-nav", "aria-label": t.next, disabled: S.month >= lastMonth, onclick: function () { set({ month: new Date(S.month.getFullYear(), S.month.getMonth() + 1, 1) }, true); } }, ["›"])
          ]));
          var grid = h("div", { class: "cog-bk-grid cog-bk-weekdays" });
          for (var w = 0; w < 7; w++) grid.appendChild(h("div", {}, [fmt({ weekday: "narrow" }, new Date(2024, 0, 1 + w))]));
          cal.appendChild(grid);
          var daysEl = h("div", { class: "cog-bk-grid" });
          var lead = (S.month.getDay() + 6) % 7;
          var count = new Date(S.month.getFullYear(), S.month.getMonth() + 1, 0).getDate();
          for (var i = 0; i < lead; i++) daysEl.appendChild(h("div", {}));
          for (var dnum = 1; dnum <= count; dnum++) {
            (function (date) {
              var k = dayKey(date), open = !!map[k];
              daysEl.appendChild(h("button", { type: "button", disabled: !open, class: "cog-bk-day" + (S.day === k ? " is-on" : open ? " is-open" : ""), onclick: function () { set({ day: k }); } }, [String(date.getDate())]));
            })(new Date(S.month.getFullYear(), S.month.getMonth(), dnum));
          }
          cal.appendChild(daysEl);
          if (S.slots && !S.slots.length) {
            cal.appendChild(h("p", { class: "cog-bk-muted cog-bk-sm" }, [t.noTimes + " ", S.month < lastMonth ? h("button", { type: "button", class: "cog-bk-link", onclick: function () { set({ month: new Date(S.month.getFullYear(), S.month.getMonth() + 1, 1) }, true); } }, [t.nextMonth]) : null]));
          }
          var right = h("div", {}, [h("div", { class: "cog-bk-strong cog-bk-sm" }, [S.day ? fmt({ weekday: "long", month: "long", day: "numeric" }, new Date(S.day + "T12:00:00")) : t.times])]);
          if (S.slots === null) {
            var sk = h("div", { class: "cog-bk-times" });
            for (var j = 0; j < 6; j++) sk.appendChild(h("div", { class: "cog-bk-skel" }));
            right.appendChild(sk);
          } else if (S.day && map[S.day]) {
            right.appendChild(h("div", { class: "cog-bk-times" }, map[S.day].map(function (s) {
              return h("button", { type: "button", class: "cog-bk-time", onclick: function () {
                set({ slot: s });
                var f = root.querySelector("form");
                if (f) f.scrollIntoView({ behavior: "smooth", block: "start" });
              } }, [fmt({ hour: "numeric", minute: "2-digit" }, new Date(s.start))]);
            })));
          } else {
            right.appendChild(h("p", { class: "cog-bk-muted cog-bk-sm" }, [t.pickDay]));
          }
          right.appendChild(h("p", { class: "cog-bk-muted cog-bk-xs" }, [t.tz + " " + zoneName()]));
          s2.appendChild(h("div", { class: "cog-bk-cols" }, [cal, right]));
        }
        box.appendChild(s2);
      }

      // 3. Details
      if (S.mode && S.slot) {
        var field = function (key, label, attrs) {
          var input = h(attrs.textarea ? "textarea" : "input", {
            class: "cog-bk-input", type: attrs.type || (attrs.textarea ? null : "text"), required: !!attrs.required, autocomplete: attrs.autocomplete || null,
            maxlength: attrs.textarea ? "2000" : null, placeholder: attrs.placeholder || null,
            oninput: function (e) { S.form[key] = e.target.value; }
          });
          input.value = S.form[key];
          return h("label", { class: "cog-bk-field" + (attrs.wide ? " is-wide" : "") }, [h("span", { class: "cog-bk-strong cog-bk-sm" }, [label]), input]);
        };
        var form = h("form", { class: "cog-bk-step", onsubmit: submit }, [
          h("h3", { class: "cog-bk-title" }, [num(3), t.step3]),
          h("div", { class: "cog-bk-fields" }, [
            field("name", t.name, { required: true, autocomplete: "name" }),
            field("email", t.email, { required: true, type: "email", autocomplete: "email" }),
            field("phone", S.mode === "phone" ? t.phoneCall : t.phoneField, { required: S.mode === "phone", type: "tel", autocomplete: "tel", wide: true }),
          ].concat(questions().map(function (q) {
            var input;
            var save = function (e) { S.answers[q.id] = e.target.value; };
            if (q.type === "choice") {
              input = h("select", { class: "cog-bk-input", required: !!q.required, onchange: save }, [h("option", { value: "" }, [t.choose])].concat((q.options || []).map(function (o) { return h("option", { value: o }, [o]); })));
            } else {
              input = h("input", { class: "cog-bk-input", type: "text", maxlength: "1000", required: !!q.required, oninput: save });
            }
            input.value = S.answers[q.id] || "";
            return h("label", { class: "cog-bk-field is-wide" }, [h("span", { class: "cog-bk-strong cog-bk-sm" }, [q.label + (q.required ? " *" : "")]), input]);
          })).concat([
            field("notes", t.notes, { textarea: true, placeholder: t.notesHint, wide: true }),
            field("guests", t.guests, { placeholder: t.guestsHint, wide: true }),
            prepNotes() ? h("div", { class: "cog-bk-prep is-wide" }, [h("p", { class: "cog-bk-strong cog-bk-sm" }, [t.prep]), h("p", { class: "cog-bk-muted cog-bk-sm cog-bk-pre" }, [prepNotes()])]) : null
          ])),
          (function () {
            var trap = h("input", { type: "text", tabindex: "-1", autocomplete: "off", "aria-hidden": "true", class: "cog-bk-trap", oninput: function (e) { S.form.website = e.target.value; } });
            return trap;
          })(),
          S.error ? h("p", { role: "alert", class: "cog-bk-err" }, [S.error]) : null,
          h("button", { type: "submit", class: "button cog-bk-submit", disabled: S.busy }, [S.busy ? t.booking : t.book])
        ]);
        box.appendChild(form);
      }
      root.appendChild(box);
    }

    render();
    fetch(proxy + "/schedules" + (link ? "?link=" + encodeURIComponent(link) : ""), { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : { schedules: [] }; })
      .then(function (d) { S.schedules = d.schedules || []; settle(); render(); loadSlots(); })
      .catch(function () { S.schedules = []; render(); });
  }

  function boot() {
    var roots = document.querySelectorAll("[data-cog-booking]");
    for (var i = 0; i < roots.length; i++) if (!roots[i].getAttribute("data-mounted")) { roots[i].setAttribute("data-mounted", "1"); mount(roots[i]); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
